import { render, staticRenderFns } from "./RolePrac.vue?vue&type=template&id=5460ecbc"
import script from "./RolePrac.vue?vue&type=script&lang=js"
export * from "./RolePrac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports